import Flex from "components/common/Layout/Flex/Flex";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  SHOW_DESCRIPTION,
  SHOW_INVESTMENT_PERIOD,
  SHOW_INVESTMENT_TYPE,
  SHOW_LOCATION_TEXT,
  SHOW_MINIMUM_INVESTMENT,
  SHOW_TARGETED_ANNUAL_CASH_YIELD,
  SHOW_TARGETED_TOTAL_RETURN,
} from "./show_property_cards_config";
import {
  Card,
  CardImage,
  Description,
  IconWithText,
  PrimaryButton,
  SecondaryInfoContainer,
  Text,
  Text2,
  TextInfo,
  Title,
  TitleReviewContainer,
} from "./ThreeColSlider";

const Wrapper = styled("div")`
  height: 100%;
  ${"" /* transition: all 0.2s; */}
  ${
    "" /* &:hover > div {
    box-shadow: 6px 16px 12px -4px rgb(0 0 0 / 35%);
  } */
  }
`;

const PropertyCard = ({
  status,
  description,
  minimumInvestment,
  targetedAnnualCashYield,
  targetedTotalReturn,
  investmentPeriod,
  investmentType,
  locationText,
  imageSrc,
  title,
  id,
  cardInstance,
  ...props
}) => {
  const navigate = useNavigate();
  const FlexProps = () => ({
    spacing: "0",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  });

  return (
    <Wrapper
      layoutId="shadow"
      whileHover={{
        scale: 1.03,
        transition: { duration: 0.2, ease: "easeInOut" },
      }}
    >
      <Card>
        <CardImage imageSrc={imageSrc} alt="property-img" />
        <TextInfo>
          <TitleReviewContainer>
            <Title>{title}</Title>
          </TitleReviewContainer>
          {SHOW_DESCRIPTION ? <Description>{description}</Description> : null}
          <Flex {...FlexProps()}>
            {/* LOCATION TEXT */}
            {SHOW_LOCATION_TEXT ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Location : "}</Text>
                  <Text2>{locationText}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
            {/* INVESTMENT TYPE */}
            {SHOW_INVESTMENT_TYPE ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Investment Type : "}</Text>
                  <Text2>{investmentType}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
            {/* INVESTMENT PERIOD */}
            {SHOW_INVESTMENT_PERIOD ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Investment Period : "}</Text>
                  <Text2>{investmentPeriod}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
            {/* TARGETED ANNUAL CASH YIELD */}
            {SHOW_TARGETED_ANNUAL_CASH_YIELD ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Targeted Annual Cash Yield : "}</Text>
                  <Text2>{targetedAnnualCashYield}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
            {/* TARGETED TOTAL RETURN */}
            {SHOW_TARGETED_TOTAL_RETURN ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Targeted Total Return : "}</Text>
                  <Text2>{targetedTotalReturn}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
            {/* MINIMUM INVESTMENT */}
            {SHOW_MINIMUM_INVESTMENT ? (
              <SecondaryInfoContainer>
                <IconWithText>
                  <Text>{"Minimum Investment : "}</Text>
                  <Text2>{minimumInvestment}</Text2>
                </IconWithText>
              </SecondaryInfoContainer>
            ) : null}
          </Flex>
        </TextInfo>
        {status ? (
          <PrimaryButton
            onClick={() => navigate(`/all-list/${id}`, { state: cardInstance })}
          >
            Invest Now
          </PrimaryButton>
        ) : (
          <PrimaryButton onClick={() => navigate(`/signup`)}>Coming Soon</PrimaryButton>
        )}
      </Card>
    </Wrapper>
  );
};

export default PropertyCard;
